import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import * as sprintDocApi from '../services/sprintDocumentService';
import type { CreateSprintDocumentInput } from '../services/sprintDocumentService';

const docKeys = {
  list: (projectId: string, sprintId: string) =>
    ['sprint-documents', projectId, sprintId] as const,
};

export function useSprintDocuments(projectId: string, sprintId: string) {
  return useQuery({
    queryKey: docKeys.list(projectId, sprintId),
    queryFn: () => sprintDocApi.fetchSprintDocuments(projectId, sprintId),
    enabled: !!projectId && !!sprintId,
  });
}

export function useCreateSprintDocument(projectId: string, sprintId: string) {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (data: CreateSprintDocumentInput) =>
      sprintDocApi.createSprintDocument(projectId, sprintId, data),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: docKeys.list(projectId, sprintId) });
    },
  });
}
